export default __webpack_public_path__ + "static/media/s8.fc2c1f40.png";